import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);

require('../application.js');

// -----------------------------------------------
// フッターコンポーネント
Vue.component('c-footer', 	require( 'js/parts_com/Footer.vue' ));

// -----------------------------------------------
// Manager コンポーネント
Vue.component('c-manager', 	require('js/parts/login/Manager.vue'));

// -----------------------------------------------
// Body コンポーネント
Vue.component('c-body', 	require('js/parts/login/Body.vue'));


// -----------------------------------------------
// 設定
import {stateSetting, mutSetting, getSetting} from 'js/state/Setting.vuex.js';

// Vuex定義
var state = stateSetting;
var mutations = mutSetting;
var actions = {};
var getters = getSetting;

// マネージャーインスタンスの管理
import {stateMgr, actMgr, mutMgr,getMgr} from 'js/state/Manager.vuex.js';

// オブジェクトをマージする。
$.extend( state, 		stateMgr);
$.extend( mutations, 	mutMgr);
$.extend( actions, 		actMgr);
$.extend( getters, 		getMgr);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

const vueName = "login";
const vueMain = new Vue({
	mixins: [
		require('js/common/main.mixin.vue'),
	],
	el: '#' + vueName,
	store,	
});



// WEBPACK FOOTER //
// ./resources/assets/js/public/auth/login.js